export const UTM_HEADER_WEB_DEMO = 'utm_source=campus_virtual&utm_medium=cta&utm_campaign=matricula_demo'
export const UTM_HEADER_WEB_STUDENT = 'utm_source=campus_virtual&utm_medium=cta&utm_campaign=matricula_alumno'
export const UTM_HEADER_WEB_MENU = 'utm_source=campus_virtual&utm_medium=cta&utm_campaign=menu'
